import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { generateUUID, getTemporaryBlockId, processChangeCard, processDeleteCard } from '../../../../../../../services/helpers/Helper';
import Action from './action';
import GalleryItem from './gallery-item';

const Gallery = (props) => {
   const { onChange, faqId } = props;
   let { data, card } = props;

   const handleAddGallery = () => {
      if (onChange) {
         let images = card.images;
         images.push({
            title: "",
            sub_title: "",
            image_url: "",
            buttons: [],
            action_type: 0
         })
         data = processChangeCard(data, { ...card, images: images }, faqId);
         onChange(data);
      }
   }

   const customPaging = (i) => {
      const element = card?.images[i].image_url ?
         <div style={{ backgroundImage: `url('${card?.images[i].image_url}')` }}></div>
         :
         <svg ariaHidden="true" focusable="false" dataPrefix="far" dataIcon="image" className="svg-inline--fa fa-image fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="currentColor"
               d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z">
            </path>
         </svg>;

      return (
         <div className="card-gallery-cursor-item-wrapper" draggable="true">
            <div className="card-gallery-item-cursor-container is_selecting">
               {element}
            </div>
         </div>
      )
   }

   const settings = {
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      customPaging: customPaging
   };

   const handleDelete = () => {
      if (onChange) {
         data = processDeleteCard(data, card, faqId);
         onChange(data);
      }
   }

   const handleCopy = () => {
      if (onChange) {

         card = {
            temporary_block_id: generateUUID(),
            type: card.type,
            title: card.title,
            images: card.images.map((m) => {
               if (m.buttons) {
                  m.buttons = m.buttons.map(m2 => {
                     return {
                        title: m2.title,
                        action: m2.action
                     }
                  });
               }
               return {
                  buttons: m.buttons,
                  sub_title: m.sub_title,
                  action_type: m.action_type,
                  title: m.title,
                  image_url: m.image_url
               };
            })
         }
         if (getTemporaryBlockId(data.first_block) === faqId) {
            data.first_block.cards = [...data.first_block.cards, card];
         }
         data.blocks = data.blocks.map(m => {
            if (getTemporaryBlockId(m) === faqId) {
               m.cards = [...m.cards, card];
            }
            return m;
         });
         onChange(data);
      }
   }

   return (
      <nav>
         <div className="card-editor fadeInDown animated">
            <div className="card-item card-item-gallery">
               <div>
                  <div className="slider-wrapper">
                     {/* <div className="slider-bar-resize">
                        <a className="focus-item focus-item2 pointer ">
                           <div className="svg-next-icon is_actived next-icon-image-ratio-horizontal">
                           </div>
                        </a>
                        <a className="focus-item pointer ">
                           <div className="svg-next-icon next-icon-image-ratio-square">
                           </div>
                        </a>
                     </div> */}
                     <div className="slider-container">
                        <div className="" >
                           <Slider {...settings}>
                              {card?.images?.map((image, index) => (
                                 <GalleryItem
                                    {...props}
                                    image={image}
                                    key={index}
                                    index={index}
                                 />
                              ))}
                           </Slider>
                        </div>
                        {/* <a className="slider-action slider-action-previous disabled">
                           <i>
                              <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="angle-left" className="svg-inline--fa fa-angle-left fa-w-8 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                 <path fill="currentColor"
                                    d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z">
                                 </path>
                              </svg>
                           </i>
                        </a> */}
                        <a className="slider-action slider-action-plus" onClick={handleAddGallery}>
                           <i>
                              <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="plus" className="svg-inline--fa fa-plus fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                 <path fill="currentColor"
                                    d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                 </path>
                              </svg>
                           </i>
                        </a>
                     </div>
                     {/* <div className="slider-cursor-bar mt15">
                        <div className="slider-cursor-bar-container" style={{ width: 42, transform: 'translate3d(0px, 0px, 0px)' }}>
                           <div className="">
                              <div className="card-gallery-cursor-item-wrapper" draggable="true">
                                 <div className="card-gallery-item-cursor-container is_selecting">
                                    <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="image" className="svg-inline--fa fa-image fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                       <path fill="currentColor"
                                          d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z">
                                       </path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div> */}
                  </div>
               </div>
            </div>
            <div className="card-action-container">
               <Action
                  onDelete={handleDelete}
                  onCopy={handleCopy}
               />
            </div>
         </div>
      </nav>
   )
}

export default Gallery;